export const projectTitle = 'Geniusbees';

const backendBaseURL = process.env.REACT_APP_BACKEND_URL;
const s3BaseURL = process.env.REACT_APP_S3_URL;

export const apiUrls = {
  AUTH: '/session',
  LOG_IN: '/login',
  LOG_OUT: '/logout',
  PARENT_LOG_OUT: '/parentLogout',
  STUDENT_LOG_OUT: '/studentLogout',
  PARENT_LOGIN: '/parent-login',
  STUDENT_LOGIN: '/student-login',
  PARENT_SIGNUP: '/parent-signup',
  VERIFY_EMAIL: '/verify-email',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  CREATE_PASSWORD: '/create-new-password',
  REFRESH_ACCESS_TOKEN: '/refresh-access-token',
  PARENT: '/parent',
  GET_PARENT_BY_ID: '/myDetails',
  STUDENT: '/student',
  DASHBOARD: '/dashboard',
  SUBJECT: '/subject',
  ASSESSMENT: '/assessment',
  PLACEMENT_EXAM: '/placement-exam',
  MODULE_INTRO: '/module-intro',
  ACTIVITY_EXAM: '/activity-exam',
  ACTIVITY: '/activity',
  LEARNING: '/learning',
  HOMEWORK: '/homework',
  COUNTRIES: '/countries',
  ACTIVITY_MANAGEMENT: '/student/activity-management',
  CHECK_REVIEW_ANSWER: '/checkReviewQuestion',
  LIST_LEARNING: '/listLearning',
  LIST_HOMEWORKS: '/response/listAllByStudent',
  ASK_FOR_HELP: '/ask-for-help',
  CONNECTION_STATUS: '/connection-status',
  ESTIMATED_MEETING_TIME: '/estimated-waiting-time',
  MEETING_REQUEST: '/meeting-request',
  MEETING_CANCEL_REQUEST: '/cancel-request',
  STATUS: '/status',
  JOIN_MEETING: '/join-meeting',
  REMOVE_USER_FROM_QUEUE: '/remove-from-queue',
  TEACHER: '/teacher',
  STUDENT_RECORD: '/studentRecord',
  LIST: '/list',
  LIST_STUDENT: '/listStudent',
  MATCH_PASSWORD: '/match-password',
  ENROLLED_SUBJECTS: '/enrolledSubject',
  ENROLL_SUBJECT: '/enrollSubject',
  STORE_ENROLL_SUBJECT: '/storeEnrollSubject',
  LEVEL: '/level',
  GET_CURRENT_ACTIVITY: '/getCurrentActivityByStudent',
  PRACTICE_SESSION_RESULTS_LIST: '/practiceSessionResultList',
  REVIEW_RESULTS_LIST: '/reviewResultList',
  EXAM_RESPONSE: '/getQuestionResponse',
  USER_RESPONSE_COUNT: '/userResponseCounts',
  GET_STUDENT: '/getStudent',
  UPLOAD: '/upload',
  GET_ASSESSMENT: '/getPlacementExam',
  GET_ASSESSMENT_RESULTS: '/getPlacementExamResults',
  SWITCH_TO_STUDENT: '/switch-to-student',
  BACK_TO_PARENT: '/back-to-parent',
  PAYMENT_DETAILS: '/payment/my-payment-invoice',
  GET_HOMEWORK_SUBMISSION: '/get-by-hs-token',
  NOT_SUBMITTED_HOMEWORK: '/get-not-submitted-homeworks',
  UPLOAD_NOT_SUBMITTED_HOMEWORK: '/upload-not-submitted-homework',
  VERIFY_HS_TOKEN: '/verify-hs-token',
  GET_SESSIONS: '/get-logged-in-history'
};

export const routeURL = {
  AUTH: '/session',
  LOG_IN: '/login',
  LOG_OUT: '/logout',
  PARENT_LOGIN: '/parent-login',
  STUDENT_LOGIN: '/student-login',
  PARENT_SIGNUP: '/parent-signup',
  VERIFY_EMAIL: '/verify-email',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  CREATE_PASSWORD: '/create-new-password',
  REFRESH_ACCESS_TOKEN: '/refresh-access-token',
  PARENT: '/parent',
  STUDENT: '/student',
  DASHBOARD: '/dashboard',
  SUBJECT: '/subject',
  ASSESSMENT: '/assessment',
  PLACEMENT_EXAM: '/placement-exam',
  MODULE_INTRO: '/module-intro',
  ACTIVITY_EXAM: '/activity-exam',
  ACTIVITY: '/activity',
  LEARNING: '/learning',
  HOMEWORK: '/homework',
  COUNTRIES: '/countries',
  ACTIVITY_MANAGEMENT: '/student/activity-management',
  CHECK_REVIEW_ANSWER: '/checkReviewQuestion',
  LIST_LEARNING: '/listLearning',
  LIST_HOMEWORKS: '/response/listAlLByStudent',
  ASK_FOR_HELP: '/ask-for-help',
  CONNECTION_STATUS: '/connection-status',
  ESTIMATED_MEETING_TIME: '/estimated-waiting-time',
  MEETING_REQUEST: '/meeting-request',
  MEETING_CANCEL_REQUEST: '/cancel-request',
  STATUS: '/status',
  JOIN_MEETING: '/join-meeting',
  REMOVE_USER_FROM_QUEUE: '/remove-from-queue',
  TEACHER: '/teacher',
  PAYMENTS: '/payments',
  MY_ACCOUNT: '/my-account'
};

const filePaths = {
  SUBJECT: s3BaseURL + '/subject/',
  QUESTION: s3BaseURL + '/question/',
  ACTIVITY: s3BaseURL + '/activity/',
  ACTIVITY_EXAM: s3BaseURL + '/activity-exam/',
  PLACEMENT_EXAM: s3BaseURL + '/placement-question/',
  LEARNING: s3BaseURL + '/learning/',
  HOMEWORK: s3BaseURL + '/homework/',
  HOMEWORK_RESPONSE: s3BaseURL + '/homework-response/',
  STUDENT: s3BaseURL + '/student-profile/',
  PARENT: s3BaseURL + '/parent-profile/'
};

export const titles = {
  REVIEW: 'Review',
  Practice_Session: 'Practice session'
};

export const regularExpressions = {
  EMAIL_REGEX: /^[a-zA-Z0-9](.?)+@[a-zA-Z0-9]+.[A-Za-z]+$/,
  PHONE_REGEX:
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
  PASSWORD_REGEX: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/,
  DECIMAL_REGEX: '^[1-9]{1,3}(,[0-9]{3})*(.[0-9]{1,2})?$',
  NEW_LINE_REGEX: /\r\n/g
};

export const help = {
  PASSWORD_HELP:
    'must Contain 8 or more characters, with a mix of uppercase, lowercase letters, numbers &symbols(!, @, #, $, %)',
  PASSWORD_MISMATCH: 'passwords didn’t match',
  INVALID_CONTACT_NUMBER: 'invalid contact number!',
  INVALID_EMAIL_ADDRESS: 'invalid email address!',
  TOO_SHORT: 'value is too short',
  VALUE_REQUIRED: 'cannot be blank',
  TERMS_CHECKED: 'must to Read and accept the Terms and conditions!',
  ENTER_EMAIL: 'please enter the email address',
  CHECK_YOUR_EMAIL: 'summary Sent to an email. Please check your email!',
  NO_QUESTION_AVAILABLE: 'no questions available for this exam right now',
  SELECTION_REQUIRED: 'must be selected',
  LOGGED_OUT_FROM_SYSTEM:
    'Oops! Your session has expired. Please log in again to keep using the app.'
};

export const errorMessages = {
  NO_ASSESSMENT_EXIST: 'There are no Assessment for this particular subject!',
  NO_QUESTION_EXIST_FOR_ASSESSMENT:
    'No questions available for this assessment right now',
  NO_QUESTION_EXIST_FOR_ACTIVITY_EXAM:
    'No questions available for this exam right now',
  SESSION_EXPIRED: 'Session expired!',
  CANNOT_GET_ACTIVITY_DATA: 'Cannot get the activity',
  SESSION_TIMEOUT: 'Session Timeout!',
  ALL_WORKSHEETS_SUBMITTED: 'All worksheets have been submitted already!'
};

export const modalActions = {
  CREATE: 'Create ',
  UPDATE: 'Update '
};

export const pagination = {
  PAGE_LIMIT: 10,
  SEARCH_LIMIT: 50,
  OFFSET: 0,
  COUNT: 0
};

export const pageOptions = [10, 10, 25, 30];

export const colors = {
  BLACK_PEARLS: '#1A2027',
  WHITE: '#ffffff',
  sideTabBGColor: '#FFF5DC'
};

export const defualtNumbers = {
  currency: 0.0
};

export const fileSize = {
  MAX: 2 * 1024 * 1024
};

export const SUPPORTED_FORMATS = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'application/pdf'
];

export const IMPORT_MEMBERS_SUPPORTED_FORMATS = [
  'application/vnd.ms-excel',
  'application/msexcel',
  'application/x-msexcel',
  'application/x-ms-excel',
  'application/x-excel',
  'application/x-dos_ms_excel',
  'application/xls',
  'application/x-xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
];

export const TIME_OUT = 8000;

export const DURATION_FORMAT = 'HH:mm:ss';

export const modules = {
  GROUP: 'Courses',
  GROUP_FEE: 'Course Fees'
};

export const dataTimeOut = {
  BASIC: 100
};

export const notSelectedOption = [
  {
    label: 'Not Selected',
    key: ''
  }
];

export const allSubjectSelection = [
  {
    label: 'All',
    key: 'all'
  }
];

export const actions = {
  ADD: 'Add',
  UPDATE: 'Update'
};

export const colorCodes = {
  WHITE: '#FFFFFF',
  CRIMSION: '#ff3c60',
  TUFTS_BLUE: '#43A4EB',
  GAINSBORO: '#dddddd',
  ORANGE: '#ff5b00',
  BLACK: '#000000'
};

export const ZOOMKeys = { CLIENT_SDK_KEY: '5wemhmAZSUK9GIEbpAVPMQ' };

export const socketIoKeys = {
  TEACHER_QUEUE_UPDATED: 'teacherQueueUpdated',
  STUDENT_QUEUE_UPDATED: 'studentQueueUpdated',
  HOST_STARTED_THE_MEETING: 'hostStartedTheMeeting'
};

const localStorageKeywords = {
  FORGOT_PASSWORD_EMAIL: 'forgot_pw_email',
  MAIL_VERIFICATION_TOKEN: 'verify_token',
  EXAM_RESULTS: 'er',
  EXAM_QUESTION_COUNT: 'eqc',
  ACTIVITY_COMPLETION_MESSAGE: 'acm'
};

const correctResponseMessages = [
  'correct_response_message_1',
  'correct_response_message_2',
  'correct_response_message_3',
  'correct_response_message_4',
  'correct_response_message_5',
  'correct_response_message_6',
  'correct_response_message_7',
  'correct_response_message_8',
  'correct_response_message_9',
  'correct_response_message_10',
  'correct_response_message_11',
  'correct_response_message_12',
  'correct_response_message_13',
  'correct_response_message_14',
  'correct_response_message_15',
  'correct_response_message_16',
  'correct_response_message_17',
  'correct_response_message_18',
  'correct_response_message_19',
  'correct_response_message_20',
  'correct_response_message_21',
  'correct_response_message_22',
  'correct_response_message_23',
  'correct_response_message_24',
  'correct_response_message_25',
  'correct_response_message_26',
  'correct_response_message_27',
  'correct_response_message_28',
  'correct_response_message_29',
  'correct_response_message_30'
];

const incorrectResponseMessages = [
  'incorrect_response_message_1',
  'incorrect_response_message_2',
  'incorrect_response_message_3',
  'incorrect_response_message_4',
  'incorrect_response_message_5',
  'incorrect_response_message_6',
  'incorrect_response_message_7',
  'incorrect_response_message_8',
  'incorrect_response_message_9',
  'incorrect_response_message_10',
  'incorrect_response_message_11',
  'incorrect_response_message_12',
  'incorrect_response_message_13',
  'incorrect_response_message_14',
  'incorrect_response_message_15',
  'incorrect_response_message_16',
  'incorrect_response_message_17',
  'incorrect_response_message_18',
  'incorrect_response_message_19',
  'incorrect_response_message_20',
  'incorrect_response_message_21',
  'incorrect_response_message_22',
  'incorrect_response_message_23',
  'incorrect_response_message_24',
  'incorrect_response_message_25',
  'incorrect_response_message_26',
  'incorrect_response_message_27',
  'incorrect_response_message_28',
  'incorrect_response_message_29',
  'incorrect_response_message_30'
];

export {
  backendBaseURL,
  s3BaseURL,
  localStorageKeywords,
  filePaths,
  correctResponseMessages,
  incorrectResponseMessages
};
